import styled from 'styled-components';

const CenteredMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
`;

const DisputeIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: block;
`;

export {
  CenteredMessage,
  DisputeIframe,
};
